import {
    useMemo,
} from 'react'
import ReactApexChart from 'react-apexcharts'
import {
    useTheme,
} from '@mui/material/styles'

import {
    Availability,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'

import getOptions from './optionsChart'

const AggregatedChart = ({
    value,
    safeMinimumUsableStock,
    containerStatus,
}: {
    value: Availability[],
    safeMinimumUsableStock: number,
    containerStatus: Record<string, boolean>,
}) => {
    const theme = useTheme()

    const categories: string[] = useMemo(() => {
        return value?.map((item) => {
            return item?.date
        })
    }, [value])

    const series = useMemo(() => {
        return value?.reduce((acc: number[], item) => {
            const sum = Object.keys(containerStatus).reduce((amount, el) => {
                return containerStatus[el] ? item[el] + amount : amount
            }, 0)

            return [
                ...acc,
                sum,
            ]
        }, [])
    }, [
        containerStatus,
        value,
    ])

    const maxValue = Math.max(...series, safeMinimumUsableStock)

    const options = useMemo(() => {
        return getOptions({
            safeMinimumUsableStock,
            categories,
            maxValue,
            theme,
        })
    }, [
        categories,
        maxValue,
        safeMinimumUsableStock,
        theme,
    ])

    return (
        <ReactApexChart
            options={options}
            height={700}
            style={{
                width: '100%',
            }}
            series={[{
                name: 'Summary',
                data: series || [],
            }]}
            type="bar"
        />
    )
}

export default AggregatedChart
